<template>
    <div class="container">
        <div class="section product">
            <div class="product-top">
                <div class="product-slider">
                    <div class="product-slider_main">
                        <vertical-slider></vertical-slider>
                    </div>
                    <div class="product-slider_img">
                        <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">
                    </div>
                </div>
                <div class="product-info">
                    <div class="page-title">Xiaomi Mi Notebook Pro 2019</div>
                    <div class="product-range">
                        <range-bar
                                :sold="342"
                                :amount="896"
                        ></range-bar>
                    </div>

                    <div class="product-price">
                        <card-price
                                :previous="'35 543'"
                                :current="'35 543'"
                        />
                    </div>
                    <div class="product-amount">
                        <div class="product-amount_control add">
                            <plus-icon size="1.5x" class="custom-class"></plus-icon>
                        </div>
                        <div class="amount">
                            {{ item.amount }}
                        </div>
                        <div class="product-amount_control substr">
                            <minus-icon size="1.5x" class="custom-class"></minus-icon>
                        </div>
                    </div>
                    <div class="product-actions">
                        <div class="product-actions__controllers">
                            <div class="add-cart">
                                <button>Добавить в корзину</button>
                            </div>
                            <div class="add-favorite">
                                <heart-icon size="24" class="svg-fill"></heart-icon>
                            </div>
                        </div>

                        <div class="product-delivery">
                            <span class="product-delivery_title">Ориентировочная дата отправки:</span>
                            <span class="product-delivery_info">14.11 - 15.11</span>
                        </div>
                    </div>
                    <div
                            class="product-description"
                            @scroll="directiveScroll($event)"
                    >
                        Ноутбук Mi Notebook Pro 15,6" оснащен 16 Гб оперативной памяти DDR4 частотой 2400 Мгц, которая работает в двухканальном режиме.
                        Два канала обработки данных обеспечивают прирост быстродействия до 80% по сравнению с одноканальным режимом.
                        В ноутбуке установлен SSD объемом 256 Гб (PCIe NVMe) через PCIe x4, что позволяет увеличить скорость чтения/записи в 4 раза.
                        Такая технология увеличивает пропускную способность накопителя в 4 раз по сравнению с накопителями SATA.
                        Кроме того, ноутбук имеет свободный слот для SSD, в который можно установить дополнительный накопитель любого объема.
                        Ноутбук Mi Notebook Pro 15,6" оснащен 16 Гб оперативной памяти DDR4 частотой 2400 Мгц, которая работает в двухканальном режиме.
                        Два канала обработки данных обеспечивают прирост быстродействия до 80% по сравнению с одноканальным режимом.
                        В ноутбуке установлен SSD объемом 256 Гб (PCIe NVMe) через PCIe x4, что позволяет увеличить скорость чтения/записи в 4 раза.
                        Такая технология увеличивает пропускную способность накопителя в 4 раз по сравнению с накопителями SATA.
                        Кроме того, ноутбук имеет свободный слот для SSD, в который можно установить дополнительный накопитель любого объема.
                    </div>
                </div>
            </div>
            <div class="product-bottom">
                <product-tabs></product-tabs>
            </div>
            <best-prod-section :show-aount="4"/>
        </div>

    </div>
</template>

<script>
    import RangeBar from '../components/Helpers/RangeBar';
    import ProductTabs from '../components/Tabs/ProductTabs';
    import VerticalSlider from '../components/VerticalSlider/VerticalSlider';
    import customScroll from "../styles/mixin.scss";

    import { HeartIcon, PlusIcon, MinusIcon } from 'vue-feather-icons';
    import BestProdSection from "../components/Sections/BestProdSection";
    import CardPrice from "../components/Helpers/CardPrice";

    export default {
        name: "ProductPage",
        components: {CardPrice, BestProdSection, ProductTabs, VerticalSlider, RangeBar, HeartIcon, PlusIcon, MinusIcon },
        mixins: [customScroll],
        data() {
            return {
                item : {
                    amount: 1
                }
            }
        },
        methods: {
            directiveScroll(e) {
                e.target.querySelector('.overflowHover') &&
                e.target.querySelector('.overflowHover').classList.remove('overflowHover');
            }
        },
    };
</script>

<style scoped lang="scss">
    .product {
        &-top {
            display: flex;
            > div {
                width: 50%;
                &:first-child {
                    margin-right: 24px;
                }
            }
        }
        &-info {
            .page-title {
                margin-bottom: 24px;
            }
        }
        &-slider {
            display: flex;
            &_main {
                width: 20%;

            }
            &_img {
                /*min-width: 500px;*/
                object-fit: contain;
                border-radius: 7px;
                width: 80%;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

                img {
                    width: 100%;
                    border-radius: 7px;
                }
            }
            &-price {
                margin-bottom: 25px;
            }
        }
        &-range {
            margin-bottom: 30px;
        }
        &-price {
            margin-bottom: 24px;
        }
        &-actions {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 32px;
            &__controllers {
                display: flex;
                align-items: center;
                .add-cart {
                    button {
                        margin-right: 24px;
                        background: linear-gradient(80.98deg, #7AC3C1 0%, #3FB0AB 100%);
                        border: none;
                        border-radius: 5px;
                        color: #FCFCFC;
                        font-size: 16px;
                        padding: 8px 24px;
                        cursor: pointer;
                    }
                }
                .add-favorite {
                    cursor: pointer;
                }
            }
        }
        &-delivery {

            &_title {
                color: #686F83;
                font-size: 14px;
                line-height: 21px;
                display: block;
            }
            &_info {
                color: #3F4450;
                font-size: 16px;
                line-height: 25px;
            }
        }
        &-amount {
            display: flex;
            border: 1px solid #D8DDE4;
            border-radius: 4px;
            width: 112px;
            height: 32px;
            margin-bottom: 24px;
            > div {
                display: flex;
                justify-content: center;
                align-items: center;
            }
            &_control {
                svg {
                    color: #6BBCBA;

                }
            }
            .add, .substr {
                width: 32px;
                height: 100%;
                cursor: pointer;
            }
            .amount {
                border-right: 1px solid #D8DDE4;
                border-left: 1px solid #D8DDE4;
                height: 100%;
                flex: 1;
            }
        }

        &-description {
            color: #686F83;

            font-size: 14px;
            line-height: 21px;

            height: 100%;
            max-height: 170px;
            overflow: auto;

            // firefox
            scrollbar-color: linear-gradient(89.71deg, #6BBCBA 0%, #3BA5A1 100%);
            scrollbar-width: thin;

            // == webkit ==
            // width
            &::-webkit-scrollbar {
                width: 5px;
                height: 8px;
                border-left: 10px;
                border-right: 10px;
                background: #EEF2F6;
                border-radius: 5px;

            }
            // Track
            &::-webkit-scrollbar-track {
                background: transparent;
                border-radius: 5px;

            }
            // Handle
            &::-webkit-scrollbar-thumb {
                border-radius: 5px;
                background: linear-gradient(89.71deg, #6BBCBA 0%, #3BA5A1 100%);
            }
            // Handle on hover
            &::-webkit-scrollbar-thumb:hover {
                background: linear-gradient(89.71deg, #6BBCBA 0%, #3BA5A1 100%);
            }
        }
    }

</style>
